import { LanguageCodeEnum } from '@systemeio/ui'
import i18next from 'i18next'
import { LocalizeValues } from 'shared/hooks/use-loco-translation'

export const addLanguageResource = async (
  languageCode: LanguageCodeEnum,
  ns: LocalizeValues,
  i18nLocal: NonNullable<typeof i18next>,
) => {
  const additionalTranslations = await import(
    `../../../../../public/locales/${languageCode}/${ns}.json`
  )
  i18nLocal.addResourceBundle(languageCode, ns, additionalTranslations, true, true)
}
